import { create } from 'zustand';
import type { AuctionSort } from '@/types/domain';

interface FiltersState {
  search: string;
  selectedTags: string[];   // slugs
  sort: AuctionSort;

  setSearch: (v: string) => void;
  toggleTag: (slug: string) => void;
  clearTags: () => void;
  setSort: (sort: AuctionSort) => void;
  reset: () => void;
}

export const useFiltersStore = create<FiltersState>((set) => ({
  search: '',
  selectedTags: [],
  sort: 'ending_soon',

  setSearch: (v) => set({ search: v }),

  toggleTag: (slug) => set((state) => ({
    selectedTags: state.selectedTags.includes(slug)
      ? state.selectedTags.filter((s) => s !== slug)
      : [...state.selectedTags, slug],
  })),

  clearTags: () => set({ selectedTags: [] }),

  setSort: (sort) => set({ sort }),

  reset: () => set({ search: '', selectedTags: [], sort: 'ending_soon' }),
}));